module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "streetmix-plus.68cd7941.svg";